import { render, staticRenderFns } from "./PaymentClaim.vue?vue&type=template&id=17d06ea7&"
import script from "./PaymentClaim.vue?vue&type=script&lang=js&"
export * from "./PaymentClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports